<template>
  <div>
    <!--Invoice body-->
      <invoice-body
        :loading="!loaded"
        :invoice="invoice"
        :invoiceid="invoiceid"
        :contact="contact"
        @pay="modal = true"
      />

    <!--Invoice payment-->
    <v-dialog v-model="modal"
              v-if="loaded"
              max-width="500px"
              eager
              @keydown.esc="closeModal"
              @click:outside="closeModal">
      <invoice-payment
        v-if="invoice.balance > 0"
        :invoice="invoice"
        compact
        @payment-complete="getInvoice"
        @close="modal = false"
      />
    </v-dialog>

    <!--Payments history-->
    <invoice-history v-if="payments.length" :payments="payments"/>

  </div>
</template>

<script>
// import amapi from '@/api/amapi'
import { mapActions, mapGetters } from 'vuex'
import InvoiceBody from './BillingInvoice/InvoiceBody'
import InvoicePayment from './BillingInvoice/InvoicePayment'
import InvoiceHistory from './BillingInvoice/InvoiceHistory'

export default {
  name: 'BillingInvoice',
  components: {
    InvoiceBody, InvoicePayment, InvoiceHistory
  },
  props: {
    invoiceid: {
      type: String,
      required: true
    }
  },
  data: () => ({
    // contact: {},
    // invoice: {},
    // payments: [],
    loaded: false,
    modal: false
  }),
  computed: {
    ...mapGetters({
      invoice: 'billing/invoice',
      contact: 'billing/contact',
      payments: 'billing/payments'
    })
  },
  methods: {
    ...mapActions({
      getInvoice: 'billing/getInvoice',
      reportError: 'reportError'
    }),
    async loadData () {
      try {
        const data = {
          id: this.invoiceid
        }

        await this.getInvoice(data)

        // const response = await amapi.makecall('invoice', { ...data })
        // if (response.result === 'success') {
        //   this.contact = response.contact
        //   this.invoice = response.invoice
        //
        //   if (response.payments) {
        //     this.payments = response.payments
        //   }
        // }
        this.loaded = true
      } catch (e) {
        await this.$router.push({
          name: 'billing'
        })
        this.reportError(e)
      }
    },
    closeModal () {
      this.modal = false
    },
  },
  created () {
    this.loadData()
  }
}
</script>
